/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { displayMessage } from "state/actions/message_status";
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
//actions
import { updateSelectedCountries, updateSelectedSites, updateSelectedDevices, updateDateRange, updateSelectedRevenueType, getAllCountries, clearHomeControls, handleReportingDelayMessage } from 'state/actions/homeState/home_analytics_status';
import { getTotalQuestionsAnswered, getTotalTopQuestionsAnswered, getTotalAverageInView, getTotalUniqueEngagedUsers, getAllRevenueMetricsTotal } from 'state/actions/homeState/home_analytics_data';
import { viewAnalytics } from 'state/actions/embedsState/embeds_status';
import HomePage from 'pages/dashboard/home/home';
// import embedsStatus from "../../../state/reducers/embedsState/embeds_status";
// import embedsStateRootReducer from "../../../state/reducers/embedsState/root";





/* ========== ~~~~~~~~~~ PAGE : HOME : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ homeState, accountData, sessionStatus, embedsState }) => {
    const { homeAnalyticsData, homeAnalyticsStatus } = homeState;

    return {
        adMetricsData: homeAnalyticsData.adMetricsData,

        questionsAnswered: homeAnalyticsData.contentPerformanceData.questionsAnswered,
        fetchingQuestions: homeAnalyticsData.contentPerformanceData.fetchingQuestions,

        topQuestionsAnswered: homeAnalyticsData.contentPerformanceData.topQuestionsAnswered,
        fetchingTopQuestion: homeAnalyticsData.contentPerformanceData.fetchingTopQuestion,

        averageInView: homeAnalyticsData.embedEngagementData.averageInView,
        fetchingAverageInView: homeAnalyticsData.embedEngagementData.fetchingAverageInView,

        uniqueEngagedUsers: homeAnalyticsData.embedEngagementData.uniqueEngagedUsers,
        fetchingUniqueEngagedUsers: homeAnalyticsData.embedEngagementData.fetchingUniqueEngagedUsers,

        revenue: homeAnalyticsData.adMetricsData.revenue,
        cpm: homeAnalyticsData.adMetricsData.cpm,
        impression: homeAnalyticsData.adMetricsData.impression,
        rmsFetching: homeAnalyticsData.adMetricsData.rmsFetching,

        devices: homeAnalyticsStatus.devices,
        selectedDevices: homeAnalyticsStatus.selectedDevices,
        countries: homeAnalyticsStatus.countries,
        selectedCountries: homeAnalyticsStatus.selectedCountries,
        sites: accountData.sites,
        selectedSites: homeAnalyticsStatus.selectedSites,
        selectedRevenueType: homeAnalyticsStatus.selectedRevenueType,
        dateRange: homeAnalyticsStatus.dateRange,
        accountUUID: sessionStatus.accountUUID,
        isDataReceived: embedsState.embedsStatus.isDataReceived,

        adMetricsPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('home.adMetrics'),
        permissionsReceived: sessionStatus.permissionsReceived
    }};

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    updateSelectedCountries: countries => dispatch(updateSelectedCountries(countries)),
    updateSelectedSites: sites => dispatch(updateSelectedSites(sites)),
    updateSelectedDevices: devices => dispatch(updateSelectedDevices(devices)),
    updateSelectedRevenueType: revenueType => dispatch(updateSelectedRevenueType(revenueType)),
    updateDateRange: range => dispatch(updateDateRange(range)),
    clearHomeControls: () => dispatch(clearHomeControls()),
    getAllCountries: (accountUUId, paramString) => dispatch(getAllCountries(accountUUId, paramString)),
    getTotalQuestionsAnswered: (paramString) => dispatch(getTotalQuestionsAnswered(paramString)),
    getTotalTopQuestionsAnswered: (paramString) => dispatch(getTotalTopQuestionsAnswered(paramString)),
    getTotalAverageInView: (paramString) => dispatch(getTotalAverageInView(paramString)),
    getTotalUniqueEngagedUsers: (paramString) => dispatch(getTotalUniqueEngagedUsers(paramString)),
    handleReportingDelayMessage: () => dispatch(handleReportingDelayMessage()),
    getAllRevenueMetricsTotal: (paramString) => dispatch(getAllRevenueMetricsTotal(paramString)),
    viewAnalytics: (embedUUID, accountUUID) => dispatch(viewAnalytics(embedUUID, accountUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage);